let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fAsl8")).then(() => parcelRequire('1T1Uj'));